import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import "utils/elements/RichTextEditor.css";

export type RichTextEditorProps = {
	value: string;
	editable: boolean;
	onChange: (value: string) => void;
};

const RichTextEditor: React.FC<RichTextEditorProps> = (
	props: RichTextEditorProps
) => {
	const [value, setValue] = useState(props.value);
	const valueRef = useRef(value);

	valueRef.current = value;

	useEffect(() => setValue(props.value), [props.value]);

	// Unmount effect.
	useEffect(() => {
		return () => onCommitValue(valueRef.current);
	}, []);

	function onCommitValue(v = value): void {
		if (props.value === v) {
			return;
		}

		if (v.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
			setValue("");
			props.onChange("");
		} else {
			props.onChange(v);
		}
	}

	const modules = {
		toolbar: [
			[{ header: [1, 2, 3, 4, false] }],
			[{ font: [] }],
			["bold", "italic", "underline", "strike"],
			[{ script: "sub" }, { script: "super" }],
			[{ align: [] }],
			[
				{ list: "ordered" },
				{ list: "bullet" },
				{ indent: "-1" },
				{ indent: "+1" }
			],
			[{ color: [] }, { background: [] }],
			["link"],
			["clean"]
		],
		clipboard: {
			matchVisual: false
		}
	};

	return (
		<ReactQuill
			theme="snow"
			modules={modules}
			value={value}
			readOnly={!props.editable}
			onChange={setValue}
			onBlur={() => onCommitValue()}
		/>
	);
};

export default RichTextEditor;
